const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de estados de cuenta',
  PAGE_DESCRIPTION:
    'En este apartado puedes visualizar y analizar de manera ordenanda tus estados de cuenta.'
};

export default HELPER_TEXTS;
